import { render, staticRenderFns } from "./ProcessaCobrancaAutomatica.vue?vue&type=template&id=73be3b11&"
import script from "./ProcessaCobrancaAutomatica.vue?vue&type=script&lang=js&"
export * from "./ProcessaCobrancaAutomatica.vue?vue&type=script&lang=js&"
import style0 from "./ProcessaCobrancaAutomatica.vue?vue&type=style&index=0&id=73be3b11&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports